import { Icon } from '@/core/icon';
import { ErrorBoundary, cx } from '@/lib';
import { Outlet, useLocation } from 'react-router-dom';
import { PageError } from './page-error';

export const Layout = () => {
  const location = useLocation();

  return (
    <main
      className={cx(
        'bg-contain bg-top bg-no-repeat bg-apple bg-phases',
        'flex flex-col items-center justify-start',
        'h-screen w-full py-20',
      )}
    >
      <Icon name='OBJECT_LOGO_TEXT' className='min-w-60 min-h-60 xl:w-[274px] xl:h-[269px]' />
      {/* A page that fails to render must not take the whole kiosk down with it. */}
      <ErrorBoundary fallback={<PageError />} resetKey={location.key}>
        <Outlet />
      </ErrorBoundary>
    </main>
  );
};
